/**
 * Datas curtas do app, num lugar só — o extrato e os cupons escrevem a mesma
 * data do mesmo jeito (`08 set`).
 */

export const MESES = [
  'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho',
  'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro',
];

/** `08 set` — o mesmo formato da data de cada linha. */
export function diaCurto(iso: string): string {
  const d = new Date(iso);
  return `${String(d.getDate()).padStart(2, '0')} ${MESES[d.getMonth()]?.slice(0, 3)}`;
}

/**
 * `2026-03-15` → `15 mar`. Dia civil da loja (`AAAA-MM-DD`): ⚠️ NUNCA por `new Date`, que
 * lê o texto como meia-noite UTC e, no fuso do Brasil, escorrega para o dia anterior.
 */
export function diaDoCalendario(dia: string): string {
  const [, mes, d] = dia.split('-');
  const nome = MESES[Number(mes) - 1]?.slice(0, 3);
  return mes && d && nome ? `${d} ${nome}` : dia;
}

/** `5 moedas` — o nome da moeda é o que a loja escolheu, não "moeda" fixo. */
export function emMoedas(quantas: number, nomeDaMoeda: string): string {
  return `${quantas} ${quantas === 1 ? nomeDaMoeda : `${nomeDaMoeda}s`}`;
}
